export const ShortArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="8"
      viewBox="0 0 60 8"
      fill="none"
    >
      <path
        d="M59.3536 4.35355C59.5488 4.15829 59.5488 3.84171 59.3536 3.64644L56.1716 0.464464C55.9763 0.269201 55.6597 0.269201 55.4645 0.464464C55.2692 0.659726 55.2692 0.976308 55.4645 1.17157L58.2929 4L55.4645 6.82842C55.2692 7.02369 55.2692 7.34027 55.4645 7.53553C55.6597 7.73079 55.9763 7.73079 56.1716 7.53553L59.3536 4.35355ZM0 4L2.18557e-08 4.5L59 4.5L59 4L59 3.5L-2.18557e-08 3.5L0 4Z"
        fill="#BFBFBF"
      />
    </svg>
  );
};
